import type { ProxyProtocol, SenderPriorityUsage } from "./custom_types";

/**
 * Runtime mirrors of backend enum schemas. `openapi-typescript` only emits
 * types, so the literal option lists used to build dropdowns live here. The
 * `satisfies` clauses keep these in sync with the generated unions.
 */
export const ProxyProtocolSchema = {
	anyOf: [
		{ const: "http", title: "HTTP", description: "HTTP" },
		{ const: "https", title: "HTTPS", description: "HTTPS" },
		{ const: "socks5", title: "SOCKS5", description: "SOCKS5" },
	],
} as const satisfies {
	anyOf: readonly {
		const: ProxyProtocol;
		title: string;
		description: string;
	}[];
};

export const SenderPriorityUsageSchema = {
	anyOf: [
		{ const: "EXCLUDED", title: "EXCLUDED", description: "EXCLUDED" },
		{ const: "LOW", title: "LOW", description: "LOW" },
		{ const: "MEDIUM", title: "MEDIUM", description: "MEDIUM" },
		{ const: "HIGH", title: "HIGH", description: "HIGH" },
		{ const: "VERY_HIGH", title: "VERY_HIGH", description: "VERY_HIGH" },
	],
} as const satisfies {
	anyOf: readonly {
		const: SenderPriorityUsage;
		title: string;
		description: string;
	}[];
};
